import styled, { css } from 'styled-components';

import { font, breakpoints } from '../../../styles/themes';
import sizes from 'utils/screenSizes';

import { spacings } from 'styles';
import * as T from './interfaces';

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (max-width: ${breakpoints.large}) {
    width: auto;
    height: auto;
    background-image: none;
  }
`;

export const ContainerCarousel = styled.div<T.IHeaderMenuStyles>`
  height: 30%;
  width: 100%;
  transition: all 0.8s ease;
  scroll-behavior: smooth;

  img {
    width: 100%;
    display: flex;
  }

  ${({ hideBanner }) =>
    hideBanner
      ? css`
          > div {
            max-height: 0px;
            min-height: 0px;

            transition: max-height 0.9s ease;
          }
        `
      : css`
          > div {
            max-height: 450px;
            min-height: 0px;
            transition: max-height 0.9s ease;
          }
        `}

  @media (min-width: ${sizes.notebook}) {
    ${props =>
      props.hideBanner &&
      'transition: 1s ease-in-out;  height: 0px;  button { display: none; }'}

    @media (max-width: ${sizes.ipadPro}) {
      ${({ hideBanner }) =>
        hideBanner
          ? css`
              > div {
                max-height: 0px;
                transition: max-height 0.5s ease;
              }
            `
          : css`
              > div {
                max-height: 450px;
                transition: max-height 0.5s ease;
              }
            `}
    }
  }
`;

export const ContainerButton = styled.div<T.IHeaderMenuStyles>`
  width: 230px;
  font-size: ${font.sizes.textXSmall};
  align-items: center;
  justify-content: center;
  display: flex;
  margin-bottom: 5px;

  @media (max-width: ${breakpoints.intermediary}) {
    width: 80%;
  }

  max-height: auto;

  ${({ hideBanner }) =>
    hideBanner
      ? css`
          transition: all 0.3s ease 0s;
          display: none;
          
        }
      `
      : css`
          display: flex;
          transition: all 0.3s ease 0s;
        }
      `}
`;

export const Highlights = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  padding: 10px 0px;

  > div {
    display: flex;
    flex-direction: row;

    width: 100%;
    padding-right: 24px;

    overflow-x: scroll;
    overflow-y: hidden;

    ::-webkit-scrollbar {
      -webkit-appearance: none;
      display: none;
      width: 0px;
      height: 0px;
    }
  }

  h1 {
    font-family: 'ChickenSansRegular';
    font-style: normal;
    font-weight: normal;
    font-size: ${font.sizes.textLarge};
    line-height: 22px;
  }

  @media only all and (min-width: ${sizes.ipad}) {
    padding: 24px 0px 24px 48px;
  }

  @media only all and (min-width: ${sizes.notebook}) {
    padding: 24px 0px 24px 0px;
    > div {
      padding-right: 0px;
    }
  }
`;

export const ContainerInput = styled.div`
  width: 80%;
  align-items: center;
  justify-content: center;
  display: flex;

  @media (max-width: ${breakpoints.intermediary}) {
    width: 90%;
    margin-top: 7px;
  }
`;

export const ContainerFilterCardapio = styled.div<T.IHeaderMenuStyles>`
  display: ${props => !props.hideSearch && 'none'};

  @media (max-width: ${breakpoints.intermediary}) {
    width: 100%;
    top: ${props =>
      props.isSearchButtonClick || props.positionFilterMobileTop
        ? '0'
        : '53px'};
    position: fixed;
    z-index: 4;
  }

  @media (min-width: ${breakpoints.intermediary}) {
    width: 99%;
    top: 98px;
    position: fixed;
    z-index: 4;
  }
`;

export const ShadowGradient = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 60px;
  background: linear-gradient(
    180deg,
    rgba(67, 64, 64, 0.6) 0%,
    rgba(67, 64, 64, 0) 100%
  );

  opacity: 0;

  @media (max-width: ${sizes.ipadPro}) {
    opacity: 0.7;
  }
`;

export const ContainerHeading = styled.div<T.IHeaderMenuStyles>`
  span {
    font-size: ${font.sizes.textSmall};
    transition: opacity 0.5s ease 0s;
    position: absolute;
  }

  h1 {
    transition: all 0.3s ease 0s;
  }

  @media (max-width: ${breakpoints.intermediary}) {
    ${props =>
      props.hideBanner
        ? css`
            height: 36px;
            display: flex;
            align-items: end;
            justify-content: center;
            margin-top: 55px;
            transition: all 0.5s ease;

            h1 {
              opacity: 0;
              //transition: all 0.3s ease 0s;
            }

            span {
              display: flex;
              transition: opacity 0.5s ease 0s;
            }
          `
        : css`
            > span {
              display: none;
              transition: opacity 0.5s ease 0s;
            }

            h1 {
              opacity: 1;
              //transition: all 0.3s ease 0s;
            }
          `}
  }

  @media (min-width: ${breakpoints.intermediary}) {
    > span {
      display: none;
    }
  }
`;

export const TitleScrolledDesktop = styled.div<T.IHeaderMenuStyles>`
  display: none;

  @media (min-width: ${breakpoints.intermediary}) {
    display: none;

    height: 100px;
    width: 99%;

    align-items: center;
    justify-content: center;
    z-index: 4;

    background: #fff;
    top: 0;
    position: fixed;
    transition: all 0.3s ease 0s;

    ${props =>
      props.hideSearch &&
      css`
        display: flex;
      `};
  }
`;
